import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTagFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_5875_132971)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.2842 3.90797C10.0742 3.61047 9.72417 3.41797 9.33333 3.41797L2.91667 3.4238C2.275 3.4238 1.75 3.94297 1.75 4.58464V10.418C1.75 11.0596 2.275 11.5788 2.91667 11.5788L9.33333 11.5846C9.72417 11.5846 10.0742 11.3921 10.2842 11.0946L12.8333 7.5013L10.2842 3.90797Z",
			fill: "#979797"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5875_132971",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgIconTagFull;
